function simulateNewfiles(fileList, idA) {
    let reader = new FileReader();
    reader.readAsDataURL(fileList);
    reader.onloadend = function () {
        let newA = document.createElement('a')
        newA.href = window.URL.createObjectURL(fileList);
        newA.innerHTML = fileList.name;
        newA.id = idA
        newA.setAttribute("target", "_blank");
        document.getElementById(idA).replaceWith(newA)
    }
}

export {simulateNewfiles}
